var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAnalytics = function SvgAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.146,
    height: 18.146,
    viewBox: "0 0 18.146 18.146",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M172.556,170.669h-1.512a.378.378,0,0,0-.378.378v4.537a.378.378,0,0,0,.378.378h1.512a.378.378,0,0,0,.378-.378v-4.537A.378.378,0,0,0,172.556,170.669Z",
    transform: "translate(-164.617 -164.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M87.223,234.669H85.711a.378.378,0,0,0-.378.378v2.268a.378.378,0,0,0,.378.378h1.512a.378.378,0,0,0,.378-.378v-2.268A.378.378,0,0,0,87.223,234.669Z",
    transform: "translate(-82.309 -226.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M257.889,106.669h-1.512a.378.378,0,0,0-.378.378v6.8a.378.378,0,0,0,.378.378h1.512a.378.378,0,0,0,.378-.378v-6.8A.378.378,0,0,0,257.889,106.669Z",
    transform: "translate(-246.926 -102.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M17.925,16.859l-4.513-4.513a7.573,7.573,0,1,0-1.069,1.069l4.513,4.513a.756.756,0,1,0,1.069-1.069ZM7.561,13.613A6.049,6.049,0,1,1,13.61,7.564,6.056,6.056,0,0,1,7.561,13.613Z",
    transform: "translate(0 -0.003)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics.f7bebda7.svg";
export { ForwardRef as ReactComponent };